var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intentRegister" },
    [
      _c("img", {
        staticClass: "banner",
        attrs: { src: "/tjkStudy/static/yxdj.png" }
      }),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "intent-content",
          attrs: { model: _vm.form }
        },
        [
          _vm._l(_vm.voList, function(item, key) {
            return [
              _vm.voList.length > 0
                ? _c(
                    "el-form-item",
                    {
                      class: { "is-required": item.requiredStatus == "YES" },
                      attrs: { label: key + 1 + "、" + item.question }
                    },
                    [
                      item.questionType == "TEXT"
                        ? [
                            _c("el-input", {
                              model: {
                                value: _vm.form.answerList[item.questionId],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.answerList,
                                    item.questionId,
                                    $$v
                                  )
                                },
                                expression: "form.answerList[item.questionId]"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "MULTIPLE_TEXT"
                        ? [
                            _c("el-input", {
                              attrs: { type: "textarea", autosize: "" },
                              model: {
                                value: _vm.form.answerList[item.questionId],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.answerList,
                                    item.questionId,
                                    $$v
                                  )
                                },
                                expression: "form.answerList[item.questionId]"
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "SINGLE_CHOICE"
                        ? [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.form.answerList[item.questionId],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.answerList,
                                      item.questionId,
                                      $$v
                                    )
                                  },
                                  expression: "form.answerList[item.questionId]"
                                }
                              },
                              [
                                _vm._l(item.choiceList, function(s) {
                                  return [
                                    _c("el-radio", {
                                      attrs: { label: s.choiceContent }
                                    })
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "MULTIPLE_CHOICE"
                        ? [
                            _c(
                              "el-checkbox-group",
                              {
                                model: {
                                  value: _vm.form.answerList[item.questionId],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form.answerList,
                                      item.questionId,
                                      $$v
                                    )
                                  },
                                  expression: "form.answerList[item.questionId]"
                                }
                              },
                              [
                                _vm._l(item.choiceList, function(m) {
                                  return [
                                    _c("el-checkbox", {
                                      attrs: { label: m.choiceContent }
                                    })
                                  ]
                                })
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "BLANK_CHOICE"
                        ? [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择省份"
                                },
                                on: { change: _vm.queryCitysFun },
                                model: {
                                  value: _vm.province,
                                  callback: function($$v) {
                                    _vm.province = $$v
                                  },
                                  expression: "province"
                                }
                              },
                              _vm._l(_vm.provinceList, function(item, key) {
                                return _c("el-option", {
                                  key: key,
                                  attrs: {
                                    label: item.provinceName,
                                    value: item.provinceName
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "170px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择地市"
                                },
                                model: {
                                  value: _vm.city,
                                  callback: function($$v) {
                                    _vm.city = $$v
                                  },
                                  expression: "city"
                                }
                              },
                              _vm._l(_vm.citysList, function(item, key) {
                                return _c("el-option", {
                                  key: key,
                                  attrs: {
                                    label: item.citysName,
                                    value: item.citysName
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      item.questionType == "IMAGE"
                        ? [
                            _c(
                              "el-upload",
                              {
                                attrs: {
                                  action: "//upload-z0.qiniup.com",
                                  "list-type": "picture-card",
                                  "on-preview": _vm.handlePictureCardPreview,
                                  "on-remove": _vm.handleRemove,
                                  data: _vm.token,
                                  "before-upload": _vm.getToken,
                                  "on-success": _vm.uploadSuccess,
                                  "file-list": _vm.fileList,
                                  limit: item.wordLimit
                                }
                              },
                              [_c("i", { staticClass: "el-icon-plus" })]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "btn" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitInfo } },
                [_vm._v("提交")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [_c("img", { attrs: { width: "100%", src: _vm.dialogImageUrl } })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c39f16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c39f16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/intentRegister.vue
// module id = 1158
// module chunks = 0